import React from 'react';
import {
    getDriverAge,
    getDriverYearsRaced,
    getTeamYearsRaced,
    getRaceWinners,
    formatAsDate,
    getFormatedDate,
} from './Utils';
import { default as RacesSearchTable } from '../../Database/Tables/Races';
import { default as DriversSearchTable } from '../../Database/Tables/Drivers';
import { default as TeamsSearchTable } from '../../Database/Tables/Teams';
import { default as ChampionshipsSearchTable } from '../../Database/Tables/Championships';
import { default as CircuitsSearchTable } from '../../Database/Tables/Circuits';

const RacesTable = ({ results }) => (
    <RacesSearchTable
        data={results.map(race => ({
            country: race._source.country,
            country_name: race._source.countryName,
            title: race._source.title,
            subtitle: race._source.raceTitle,
            race_date: formatAsDate(race._source.raceStartDate),
            race_date_str: getFormatedDate(race._source.raceStartDate),
            championship_type: race._source.championship || 'Non-championship',
            race_winner: getRaceWinners(race) || [
                {
                    name: 'N/A',
                    url: '',
                },
            ],
            url: race._source.permalink,
        }))}
        initialState={{ pageSize: 16, pageIndex: 0, sortBy: [{ id: 'race_date', desc: true }] }}
        searchTable={true}
    />
);

const DriversTable = ({ results }) => {
    const sortedDrivers = results.map(driver => {
        let split_last_name = driver._source.title.split(' ', 2)[1];

        if (split_last_name === undefined) {
            split_last_name = driver._source.title;
        }

        const died = ('dateOfDeath' in driver._source && driver._source.dateOfDeath !== '') || 
            ('yearOfDeath' in driver._source && driver._source.yearOfDeath !== '') || 
            ('yearOfDeathCirca' in driver._source && driver._source.yearOfDeathCirca !== '');

        return {
            last_name: driver._source.title,
            split_last_name,
            country: driver._source.country,
            country_name: driver._source.countryName,
            age: getDriverAge(driver),
            died: died,
            dateOfDeath: 'dateOfDeath' in driver._source ? driver._source.dateOfDeath : '',
            yearOfDeath: 'yearOfDeath' in driver._source ? driver._source.yearOfDeath : '',
            yearOfDeathCirca: 'yearOfDeathCirca' in driver._source ? driver._source.yearOfDeathCirca : '',
            years_raced: getDriverYearsRaced(driver),
            url: driver._source.permalink,
            image: driver._source.image,
        };
    });

    return <DriversSearchTable data={sortedDrivers} initialState={{ pageSize: 16, pageIndex: 0 }} searchTable={true} />;
};

const TeamsTable = ({ results }) => (
    <TeamsSearchTable
        data={results.map(team => ({
            title: team._source.title,
            country: team._source.country,
            country_name: team._source.countryName,
            years_raced: getTeamYearsRaced(team),
            url: team._source.permalink,
            image: team._source.image,
        }))}
        initialState={{ pageSize: 16, pageIndex: 0, sortBy: [{ id: 'title', desc: false }] }}
        searchTable={true}
    />
);

const ChampionshipsTable = ({ results }) => (
    <ChampionshipsSearchTable
        data={results.map(championship => ({
            title: championship._source.title,
            season: championship._source.season[0],
            series: championship._source.championshipGroup[0],
            race_winner: championship._source.champions || [
                {
                    name: championship._source.driversChampion,
                    url: '',
                },
            ],
            url: championship._source.permalink,
        }))}
        initialState={{ pageSize: 16, pageIndex: 0, sortBy: [{ id: 'season', desc: true }] }}
        searchTable={true}
    />
);

const CircuitsTable = ({ results }) => (
    <CircuitsSearchTable
        data={results.map(circuit => ({
            country: circuit._source.country,
            country_name: circuit._source.countryName,
            title: circuit._source.title,
            subtitle: circuit._source.officialName,
            length: circuit._source.circuitTotalDistance,
            starting_year: circuit._source.startingYear,
            ending_year: circuit._source.endingYear || 'To Present',
            url: circuit._source.permalink,
        }))}
        initialState={{ pageSize: 16, pageIndex: 0, sortBy: [{ id: 'title', desc: false }] }}
        searchTable={true}
    />
);

export { RacesTable, DriversTable, TeamsTable, ChampionshipsTable, CircuitsTable };
